// @ts-nocheck
import { PropsWithChildren } from 'react';
import { BottomNav } from './BottomNav';
import { MobilePushPermissionBanner } from './MobilePushPermissionBanner';
import { NotificationDropdown } from '@/components/NotificationDropdown';
import { NavLink, useLocation } from 'react-router-dom';
import {
  Sheet, SheetContent, SheetTrigger,
} from '@/components/ui/sheet';
import { Button } from '@/components/ui/button';
import { Separator } from '@/components/ui/separator';
import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';
import { useAuth } from '@/contexts/AuthContext';
import {
  Menu,
  LayoutDashboard,
  Users,
  Calendar,
  Scale,
  PhoneCall,
  Wallet,
  CheckSquare,
  User,
  Bell,
  LogOut,
  Search,
} from 'lucide-react';
import { supabase } from '@/integrations/supabase/client';

// Ordem fiel ao BottomNav + secundárias abaixo.
const primaryLinks = [
  { to: '/pwa/dashboard', icon: LayoutDashboard, label: 'Dashboard' },
  { to: '/pwa/cases',     icon: Scale,           label: 'Processos' },
  { to: '/pwa/agenda',    icon: Calendar,        label: 'Agenda' },
  { to: '/pwa/clients',   icon: Users,           label: 'Clientes' },
  { to: '/pwa/financial', icon: Wallet,          label: 'Financeiro' },
];

const secondaryLinks = [
  { to: '/pwa/tasks',         icon: CheckSquare, label: 'Tarefas' },
  { to: '/pwa/appointments',  icon: PhoneCall,   label: 'Atendimentos' },
  { to: '/pwa/notifications', icon: Bell,        label: 'Notificações' },
  { to: '/pwa/profile',       icon: User,        label: 'Perfil' },
];

const TITLE_MAP: Record<string, string> = {
  '/pwa/dashboard':     'Dashboard',
  '/pwa/cases':         'Processos',
  '/pwa/agenda':        'Agenda',
  '/pwa/clients':       'Clientes',
  '/pwa/financial':     'Financeiro',
  '/pwa/tasks':         'Tarefas',
  '/pwa/appointments':  'Atendimentos',
  '/pwa/notifications': 'Notificações',
  '/pwa/profile':       'Perfil',
};

const getTitle = (pathname: string): string => {
  if (pathname.startsWith('/pwa/processo')) return 'Processo';
  return TITLE_MAP[pathname] || 'Allana Advocacia';
};

export const MobileLayout = ({ children }: PropsWithChildren) => {
  const { profile, user } = useAuth();

  const handleLogout = async () => {
    try {
      await supabase.auth.signOut();
    } finally {
      window.location.href = '/pwa/auth';
    }
  };

  return (
    <div
      className="pwa-brand min-h-screen flex flex-col bg-[#faf8f4] text-slate-900"
    >
      {/* Header */}
      <header
        className="sticky top-0 z-40 bg-slate-900 shadow-[0_8px_24px_-18px_rgba(15,23,42,0.6)]"
        style={{
          // iPhone: a faixa escura passa por trás da barra de status
          paddingTop: 'env(safe-area-inset-top)',
          paddingBottom: '0px',
        }}
      >
        <div>
          <div className="flex items-center justify-between w-full border-b border-[#c4ab83]/40 bg-slate-900 px-2 py-2">
            <div className="flex items-center gap-1.5 min-w-0">
            {/* Menu lateral */}
            <Sheet>
              <SheetTrigger asChild>
                <Button variant="ghost" size="icon" className="h-9 w-9 rounded-xl text-[#c4ab83] hover:text-[#d8c39c] hover:bg-[#c4ab83]/10" aria-label="Menu">
                  <Menu className="h-5 w-5" />
                </Button>
              </SheetTrigger>
              <SheetContent
                side="left"
                className="p-0 w-[300px] flex flex-col"
                style={{ paddingTop: 'env(safe-area-inset-top)' }}
              >
                <div className="p-5 flex items-center gap-3 bg-slate-900 text-[#c4ab83] border-b border-[#c4ab83]/30">
                  <div className="h-12 w-12 rounded-xl bg-black/70 border border-[#c4ab83]/50 flex items-center justify-center shadow-[0_0_0_1px_rgba(212,175,55,0.15)]">
                    <img
                      src="/logoasad.png"
                      alt="Logo"
                      className="h-10 w-10 rounded-lg object-cover"
                    />
                  </div>
                  <div>
                    <p className="font-bold text-base leading-tight tracking-tight">Allana Sthéfany</p>
                    <p className="text-xs text-[#e8dcc4]">Advocacia & Consultoria</p>
                  </div>
                </div>
                <Separator />
                <nav className="p-2 flex-1 overflow-y-auto">
                  <p className="px-3 pt-2 pb-1 text-[10px] uppercase tracking-wide text-muted-foreground font-semibold">
                    Principal
                  </p>
                  {primaryLinks.map(({ to, icon: Icon, label }) => (
                    <NavLink
                      key={to}
                      to={to}
                      className={({ isActive }) =>
                        `flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm transition-colors ${
                          isActive
                            ? 'bg-primary/10 text-primary font-medium'
                            : 'text-foreground hover:bg-muted'
                        }`
                      }
                    >
                      <Icon className="h-4 w-4 shrink-0" />
                      {label}
                    </NavLink>
                  ))}

                  <p className="px-3 pt-4 pb-1 text-[10px] uppercase tracking-wide text-muted-foreground font-semibold">
                    Mais
                  </p>
                  {secondaryLinks.map(({ to, icon: Icon, label }) => (
                    <NavLink
                      key={to}
                      to={to}
                      className={({ isActive }) =>
                        `flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm transition-colors ${
                          isActive
                            ? 'bg-primary/10 text-primary font-medium'
                            : 'text-foreground hover:bg-muted'
                        }`
                      }
                    >
                      <Icon className="h-4 w-4 shrink-0" />
                      {label}
                    </NavLink>
                  ))}

                  <Separator className="my-3" />
                  <button
                    onClick={handleLogout}
                    className="flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm w-full text-left text-muted-foreground hover:bg-destructive/10 hover:text-destructive transition-colors"
                  >
                    <LogOut className="h-4 w-4 shrink-0" />
                    Sair
                  </button>
                </nav>
                <div className="p-4 border-t border-border text-center">
                  <p className="text-[10px] text-muted-foreground">
                    PWA v4 · iOS & Android · Push nativo
                  </p>
                </div>
              </SheetContent>
            </Sheet>

            {/* Marca à esquerda (como app nativo) */}
            <div className="min-w-0 flex items-center ml-0">
              <img
                src="/logoasad.png"
                alt="Allana Sthéfany Advocacia"
                className="h-8 w-auto max-w-[120px] object-contain"
              />
            </div>
            </div>

            {/* Ações topo */}
            <div className="flex items-center gap-1 shrink-0 pl-0.5">
              <Button
                variant="ghost"
                size="icon"
                className="h-9 w-9 rounded-xl text-[#c4ab83] hover:text-[#d8c39c] hover:bg-[#c4ab83]/10 max-[390px]:h-8 max-[390px]:w-8"
                aria-label="Buscar"
              >
                <Search className="h-[18px] w-[18px]" />
              </Button>
              <NotificationDropdown className="h-9 w-9 rounded-xl !text-[#c4ab83] hover:!text-[#d8c39c] hover:bg-[#c4ab83]/10 max-[390px]:h-8 max-[390px]:w-8" />
              <Avatar className="h-9 w-9 border border-[#c4ab83]/50 shadow-sm max-[390px]:h-8 max-[390px]:w-8">
                <AvatarImage src={profile?.avatar_url || ''} alt={profile?.full_name || user?.email || 'Usuário'} />
                <AvatarFallback className="text-[11px] font-semibold bg-[#c4ab83] text-black">
                  {(profile?.full_name || user?.email || 'U').trim().charAt(0).toUpperCase()}
                </AvatarFallback>
              </Avatar>
            </div>
          </div>
        </div>
      </header>

      {/* Banner persistente de permissão de push (só aparece se necessário) */}
      <MobilePushPermissionBanner />

      {/* Conteúdo principal */}
      <main
        className="flex-1 overflow-y-auto"
        style={{ paddingBottom: 'calc(72px + env(safe-area-inset-bottom))' }}
      >
        {children}
      </main>

      {/* Bottom Nav com os 5 principais */}
      <BottomNav />
    </div>
  );
};
